import { tabStore } from '@/features/tabs/tabs.store';
import { NEW_CHAT_ID } from '@/utils/constants';

import { getProjectDraftId, getTabDraftId } from './draft-ids';

/**
 * Computes the draft ID based on context:
 * - Existing thread: uses threadId
 * - New chat in project: `project:{projectId}`
 * - New chat in tab: `tab:{tabId}`
 */
export const getDraftId = (
  threadId: string,
  projectId: string | null | undefined
): string => {
  if (threadId !== NEW_CHAT_ID) {
    return threadId;
  }
  if (projectId) {
    return getProjectDraftId(projectId);
  }
  const activeTabId = tabStore.activeTabId;
  if (activeTabId) {
    return getTabDraftId(activeTabId);
  }
  return NEW_CHAT_ID;
};
